import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives — the fifth one it has got
  // wrong, after `sustainability-innovation`,
  // `importance-of-measurement-for-transformation-success`,
  // `ai-in-fashion-retail` and `leaders-guide-to-generative-ai`. The reference
  // screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/ai-grocery-shopping/` on 2026-08-28 (the
  // filenames carry the address), so the address is the short one and the
  // whole-title guess was wrong.
  'ai-grocery-shopping',
  'How Grocery Retail Leaders Are Preparing the Shopping Season',
  `${UPLOADS}/2025/09/grocery-shopping-season-preparing-400x400.jpg`,
  {
    confirmed: true,
    // The two shopping-season files are the only pair whose names do not carry
    // their book's title. This is the grocery one by elimination — the other
    // says "in Fashion Retail" — and by position: the fifteen links arrived in
    // this list's exact order.
    download: pdf(
      '13db563d-e647-4379-b1b8-2e81c1ea7010-Lead the Shopping Season with AI-Powered Strategies.pdf',
    ),
    // Designed as its own written page on 2026-08-28, the sixth — so the card
    // goes there and `prerender.tsx` skips it, rather than generating this
    // template over the top of it.
    href: '/en/impact-labs/ebooks/ai-grocery-shopping',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 3
